module.exports = __webpack_public_path__ + "images/3015625ff5fdcdd7d2fb5f6cde685ad8.png";